export const USERCHAT_ID = "USERCHAT_ID";
export const DELETE_ID   = "DELETE_ID";



export const userChatIdAction = (value) => ({
  type: USERCHAT_ID,
  payload: value
});


export const userDeleteByIdAction = (id) => ({
  type: DELETE_ID,
  payload: id
})


